import { ControlDetailOverviewDataService } from "@app/controls/detail-overview/control-detail-overview.data.service";
import { Component, Input, OnInit, inject } from "@angular/core";
import { ControlDetailOverviewModel } from "@app/controls/detail-overview/ControlDetailOverviewModel";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { firstValueFrom } from "rxjs";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { DateFormatPipe } from "@app/shared/pipes/date-format.pipe";
import { EffExpansionPanelComponent } from "../../common/eff-expansion-panel/eff-expansion-panel.component";
import { EffButtonComponent } from "../../common/eff-button/eff-button.component";

@Component({
    selector: "eff-control-info-box",
    templateUrl: "./eff-control-info-box.component.html",
    styleUrls: ["./eff-control-info-box.component.scss"],
    imports: [TranslatePipe, DateFormatPipe, EffExpansionPanelComponent, EffButtonComponent],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffControlInfoBoxComponent implements OnInit {
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _controlService = inject(ControlDetailOverviewDataService);

    @Input() controlGuid: string;
    @Input() effectivenessGuid: string;
    @Input() testingCompleted: boolean = false;

    @Input() panelOpenState: boolean = false;

    controlInfo: ControlDetailOverviewModel = undefined;

    async ngOnInit() {
        await this.loadControlInfo();
    }

    async loadControlInfo() {
        if (this.controlInfo) {
            return;
        }

        if (this.testingCompleted) {
            this.controlInfo = await firstValueFrom(
                this._controlService.getCompletedTestControlOverview(
                    this.controlGuid,
                    this.effectivenessGuid
                )
            );
        } else {
            this.controlInfo = await firstValueFrom(
                this._controlService.getControlOverview(this.controlGuid)
            );
        }
    }

    openControl() {
        this._tabService.generateTab(this._pages.ControlDetail, this.controlGuid);
    }

    openEffOverview() {
        this._tabService.generateTab(
            this._pages.ControlsTestingAdvEffControlOverview,
            this.controlGuid
        );
    }
}
